import { ObservableArray, View } from "binder"
import { ProductionStopListEditorViewModel } from "./productionStopListEditor-viewModel"
import { StopReasonSelectorViewModel } from "../Selectors/stopReasonSelector-viewModel";
import { ProductLineSelectorViewModel } from "../Selectors/productLineSelector-viewModel";
import { WorkStationSelectorViewModel } from "../Selectors/workStationSelector-viewModel";
import { TimeSelectorViewModel } from "uicomponents";
import { TimePart } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class ProductionStopListEditorView extends View<ProductionStopListEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-1A4C70E3-2C3F-4771-ADF0-CD10343CD245"
    }
    loadHtml(): string {
        let element = require('./productionStopListEditor.html').default;
        let style = require('./productionStopListEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set date(v: string) { this._date = v; } public get date(): string { return this._date; } private _date: string;
    public set time(v: string) { this._time = v; } public get time(): string { return this._time; } private _time: string;
    public set productLineId(v: string) { this._productLineId = v; } public get productLineId(): string { return this._productLineId; } private _productLineId: string;
    public set productLineSelector(v: ProductLineSelectorViewModel) { this._productLineSelector = v; } public get productLineSelector(): ProductLineSelectorViewModel { return this._productLineSelector; } private _productLineSelector: ProductLineSelectorViewModel;
    public set workStationId(v: string) { this._workStationId = v; } public get workStationId(): string { return this._workStationId; } private _workStationId: string;
    public set workStationSelector(v: WorkStationSelectorViewModel) { this._workStationSelector = v; } public get workStationSelector(): WorkStationSelectorViewModel { return this._workStationSelector; } private _workStationSelector: WorkStationSelectorViewModel;
    public set stopReasonId(v: string) { this._stopReasonId = v; } public get stopReasonId(): string { return this._stopReasonId; } private _stopReasonId: string;
    public set stopReasonSelector(v: StopReasonSelectorViewModel) { this._stopReasonSelector = v; } public get stopReasonSelector(): StopReasonSelectorViewModel { return this._stopReasonSelector; } private _stopReasonSelector: StopReasonSelectorViewModel;
    public set timeSelector(v: TimeSelectorViewModel) { this._timeSelector = v; } public get timeSelector(): TimeSelectorViewModel { return this._timeSelector; } private _timeSelector: TimeSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
